import React, {Fragment} from "react";
import {makeStyles} from "@material-ui/core/styles";
const useStyles = makeStyles( theme => ({
        button: {
            width: '33px',
            filter: theme.overrides.iconFilter.filter
        },
    })
);
const AppbarUserProfileIcon = () => {

    const classes = useStyles();

    return (
        <Fragment>
            <img src={require('../../assets/icons/TopMenu_Profile.svg')} alt={'alt'} className={classes.button} />
        </Fragment>
    )
}

export default AppbarUserProfileIcon;
